<div class="row" id="CsaRow">
  <div class="col-md-12" id="CsaCol">
    <mat-card appearance="outlined" class="marB16" id="CsaMatCard">
      <div *ngIf="editactivity">
        <button mat-icon-button class="close-button" [mat-dialog-close]="true" id="CsaBtn" name="suitabilitydialogbtn">
          <mat-icon class="close-icon" color="warn" id="CsaIcon">close</mat-icon>
        </button>
      </div>

      <div class="d-flex justify-content-between" style="margin-left: 18px; margin-top: 18px">
        <div class="txt_left">
          <h4 class="h3Header GreyDarkest text-1line marB16" id="CsaHeader">
            {{ checkSuitabilityDataObj.activityName }}
          </h4>
        </div>
        <div class="d-flex" style="margin-right: 18px">
          <div class="txt_left">
            <h4 class="h3Header GreyDarkest text-1line marB16" id="CsaActivityName">
              {{ checkSuitabilityDataObj.activityName }}
            </h4>
          </div>
          <span class="data-letters float-left marR6 listleft" id="CsaList">
            {{ loginUserName || 'NA' | initials }}
          </span>
          <h5 class="marginicon40 h5Header GreyLight marT8 float-right marR16" id="CsaH5">{{ loginUserName }}</h5>
          <span class="float-right marT4">
            <span
              class="marginicon40 mainBodyTxt3 GreyLight blockInfo"
              *ngIf="timeModifiedOn; else elseTemplate"
              id="CsaDate"
            >
              {{ timeModifiedOn | dateTransform }}
            </span>
            <ng-template class="mainBodyTxt3 GreyLight blockInfo" #elseTemplate id="CsaTemp"> </ng-template>
          </span>
        </div>
      </div>

      <mat-card-content class="clearfix" *ngIf="isCollapsed" [ngClass]="{ readActivityDisable: data && data.readflag }">
        <form name="suitabilityForm" #f1="ngForm" id="CsaForm">
          <div *ngIf="this.testformValid(!f1.invalid)"></div>
          <mat-form-field class="custom-form-field">
            <input
              matInput
              placeholder="Notes"
              name="notes"
              required
              [(ngModel)]="notes"
              [value]="notes"
              (input)="notes = $event.target.value"
            />
          </mat-form-field>

          <mat-card appearance="outlined">
            <app-attachment
              (fileOutput)="receiveFileOutput($event)"
              (existingFile)="recieveExistingFile($event)"
              [toggleBtn]="toggleBtn"
              [allowedTypes]="allowedTypes"
              [uploadType]="multiple"
              [editId]="editId"
              activityModuleFlag="true"
            ></app-attachment>
          </mat-card>

          <div class="row" *ngIf="!ifCoupled">
            <div class="col-md-2">
              <div class="row nomarLR padTB16">
                <button
                  mat-raised-button
                  class="primary-btn btnfullWdth"
                  name="suitabilityFormBtn"
                  type="submit"
                  [disabled]="f1.invalid"
                  (click)="activityAction()"
                >
                  Send
                </button>
              </div>
            </div>
          </div>
        </form>
      </mat-card-content>
      <mat-card-actions class="collapseAction">
        <div>
          <a
            href="javascript:void(0)"
            [ngClass]="isCollapsed ? 'icon x-24 up-arw-icon' : 'icon x-24 down-arw-icon'"
            (click)="showMoreLess()"
          ></a>
        </div>
      </mat-card-actions>
    </mat-card>
  </div>
</div>
